// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__e8WrE","meta":"styles_meta__3wwRV"};